import { render, staticRenderFns } from "./AssetsRepositories.vue?vue&type=template&id=d0091d90&scoped=true"
import script from "./AssetsRepositories.vue?vue&type=script&lang=js"
export * from "./AssetsRepositories.vue?vue&type=script&lang=js"
import style0 from "./AssetsRepositories.vue?vue&type=style&index=0&id=d0091d90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0091d90",
  null
  
)

export default component.exports